import React, { useCallback, useContext, useRef } from "react";
import _, { debounce } from "underscore";
import "./BarcodePdf.css";
import Header from "../../components/header";
import { Button, Form, Spinner } from "react-bootstrap";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
// import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader";
import Context from "../../context/context";
import toast from "react-hot-toast";
import ErrosToast from "../../components/ErrosToast";
import Swal from "sweetalert2";
import POTypeChange from "./supports/POTypeChange";
import FUCSChange from "./supports/FCUSChange";
import PreviewModal from "./supports/PreviewModal";
import StickerTypeChange from "./supports/StickerTypeChange";
const MAX_RETRIES = 10;

const BarcodePdf = () => {
  const [entryByPOdata, setEntryByPOdata] = useState([]); // to store the data of api /entry/getAllByPO
  const [filteredEntryByPOdata, setFilteredEntryByPOdata] = useState([]);
  const [isLoading, setIsLoading] = useState(false); //
  const [sentCheckBox, setSentCheckBox] = useState(false);
  const [unsentCheckBox, setUnsentCheckBox] = useState(true);

  const [initialFetchDone, setInitialFetchDone] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);

  const [poSearch, setPoSearch] = useState("");
  const [selectedStickerValue, setSelectedStickerValue] = useState("");
  const [customerSearch, setCustomerSearch] = useState("");
  const [lShimpentSearch, setlShimpentSearch] = useState("");
  const [type, setType] = useState("");

  const [checkedPO, setCheckedPO] = useState([]);
  const [selectedPOAndBoxgorup, setSelectedPOAndBoxgroup] = useState([]);
  const [loadingMergeBoxGroup, setLoadingMergeBoxGroup] = useState(false);

  // Preview Modal states
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewHtmlContent, setPreviewHtmlContent] = useState({});
  const [barcodeContent, setBarcodeContent] = useState([]);

  const ctx = useContext(Context);
  const new_array = ctx.userData.leftBarcode.split("");

  const observerRef = useRef(null);
  const loadingRef = useRef(false);

  const name = ctx.userData.username;
  const fetchData = async (
    sentCheckBox,
    unsentCheckBox,
    pageNo,
    limit = 30,
    poSearch,
    selectedStickerValue = "",
    customerSearch,
    lShimpentSearch,
    type
  ) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setIsLoading(true);
    try {
      const res = await axios.get(
        `/entry/getAllByPO?sent=${sentCheckBox}&unsent=${unsentCheckBox}&pageNo=${pageNo}&docNo=${limit}&po=${poSearch}&cust=${customerSearch}&lerrosShip=${lShimpentSearch}&typFilter=${type}&typeSticker=${selectedStickerValue}
`
      );

      setFilteredEntryByPOdata((prev) => [
        ...(prev || []),
        ...res.data.entries,
      ]);
      const checkboxStates = Array(res.data.entries.length).fill(false);
      setCheckedPO((prev) => [...(prev || []), ...checkboxStates]);
      setSelectedPOAndBoxgroup([]);
      setEntryByPOdata((prev) => [...(prev || []), ...res.data.entries]);

      setHasMore(res.data.entries.length === 30);
      if (pageNo === 0) {
        setInitialFetchDone(true);
      } else {
        setPage((prevPage) => prevPage + 1);
      }
    } catch (err) {
      console.log(err);
    } finally {
      loadingRef.current = false;
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setPage(0);
    setEntryByPOdata([]);
    setFilteredEntryByPOdata([]);

    fetchData(
      sentCheckBox,
      unsentCheckBox,
      0,
      30,
      poSearch,
      selectedStickerValue,
      customerSearch,
      lShimpentSearch,
      type
    ); // initial load
  }, [sentCheckBox, unsentCheckBox]);

  const observerCallback = useCallback(
    (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && hasMore && !loadingRef.current) {
        fetchData(
          sentCheckBox,
          unsentCheckBox,
          page + 1,
          30,
          poSearch,
          selectedStickerValue,
          customerSearch,
          lShimpentSearch,
          type
        );
      }
    },
    [
      page,
      hasMore,
      initialFetchDone,
      sentCheckBox,
      unsentCheckBox,
      poSearch,
      selectedStickerValue,
      customerSearch,
      lShimpentSearch,
      type,
    ]
  );

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback);
    const target = observerRef.current;
    // console.log('target check', target)
    if (target) observer.observe(target);
    return () => {
      if (target) observer.unobserve(target);
    };
  }, [observerCallback]);

  const OnChangeHandleFilter = useCallback(
    // for filter by every letter

    debounce(
      (
        poSearch,
        customerSearch,
        lShimpentSearch,
        type,
        sentCheckBox,
        unsentCheckBox,
        selectedStickerValue
      ) => {
        setPage(0);
        setEntryByPOdata([]);
        setCheckedPO([]);
        setHasMore(true);

        fetchData(
          sentCheckBox,
          unsentCheckBox,
          0,
          30,
          poSearch,
          selectedStickerValue,
          customerSearch,
          lShimpentSearch,
          type
        );
      },
      2000,
      false
    ),
    [selectedStickerValue]
    // []
  );

  let barcodeGenerating = false;

  const BarcodeButton = ({ PO, BoxGroup, user_to_use = null }) => {
    const [generating, setGenerating] = useState(false);
    async function generateBarcode(retries = 0) {
      if (barcodeGenerating) {
        toast.remove();
        toast.error("Another Barcode PDF is generating, Please wait!");
        return;
      }

      barcodeGenerating = true;
      setGenerating(true);
      const checkBoxGroup =
        BoxGroup === null || BoxGroup === undefined || BoxGroup === ""
          ? ""
          : BoxGroup;
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_LINK}/api/v1/csv/generateBarcodes?PO=${PO}&BoxGroup=${checkBoxGroup}&user_to_use=${user_to_use}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        window.location.assign(
          `${process.env.REACT_APP_API_LINK}/api/v1/csv/download?oneTimeToken=${res.data.downloadToken}`
        );

        try {
          const profileRes = await axios.get("/auth/getProfile");
          ctx.setUserData(profileRes.data.user);
        } catch (err) {
          console.log(err);
        }

        toast.remove();
        if (BoxGroup !== null) {
          toast.success("Barcode range re-printed successfully");
        } else {
          toast.success("Barcode generated successfully");
        }
        setGenerating(false);
        setSentCheckBox(true);
        setUnsentCheckBox(false);
        setHasMore(true);
        setEntryByPOdata([]);
        setFilteredEntryByPOdata([]);
        fetchData(
          true,
          false,
          0,
          30,
          poSearch,
          selectedStickerValue,
          customerSearch,
          lShimpentSearch,
          type
        );
        // console.log("ctx po data length", ctx.poData.length);
        if (ctx.poData.length > 0) {
          const lockedData = await axios.post(
            process.env.REACT_APP_API_LINK +
              "/api/v1/po/getLockedPurchaseOrders",
            {
              POIDs: ctx.selectedCheckboxes,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          ctx.setLastBCGeneratedSNo(lockedData.data.lastBCGeneratedSNo);
          ctx.setLastTo(lockedData.data.lastValueOfTo);
        }
      } catch (err) {
        const status = _.get(err, ["response", "status"], 0);

        if (status === 429 && retries < MAX_RETRIES) {
          console.log(
            `Too many requests. Retrying in 5 seconds... (${
              retries + 1
            }/${MAX_RETRIES})`
          );
          setTimeout(() => generateBarcode(retries + 1), 5000);
        } else {
          setGenerating(false);
          console.log(err);
          toast.remove();
          ErrosToast(_.get(err, "response.data.message", "An error occurred"));
        }
      } finally {
        ctx.setFilteredEntries([]);
        barcodeGenerating = false;
      }
    }

    const DownloadBarcodePdf = async () => {
      let alertCheck = false;
      const hasBoxGroup = BoxGroup && BoxGroup.trim();

      if (!hasBoxGroup) {
        const result = await Swal.fire({
          html: `Make sure that all boxes are packed and entered into the system for this P.O. and shipment. 
          <br><br> If you generate a barcode PDF for <strong>${PO}</strong>, the next box group's sequence will start from 1. Do you want to proceed?`,
          showCancelButton: true,
          confirmButtonText: "Yes, proceed",
          cancelButtonText: "Cancel",
          position: "center",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-confirm-button",
            cancelButton: "custom-cancel-button",
          },
        });

        if (result.isConfirmed) {
          // If the user clicks "Yes, proceed"
          alertCheck = true;
          await generateBarcode(); // Call the function to generate the barcode
        } else {
          setGenerating(false); // Optional: Reset the generating state
        }
      } else {
        // If `BoxGroup` is not empty
        await generateBarcode();
      }
    };

    return (
      <button
        className="btn btn-none "
        onClick={() => {
          DownloadBarcodePdf();
        }}
        disabled={generating}
      >
        {generating ? (
          <Spinner size="lg" />
        ) : (
          <img
            width="37"
            height="37"
            src="https://img.icons8.com/cotton/64/barcode-scanner--v3.png"
            alt="barcode-scanner--v3"
          />
        )}
      </button>
    );
  };
  const ExcelButton = ({ PO, STY, BoxGroup }) => {
    const [generating, setGenerating] = useState(false);

    const DownloadExcel = () => {
      setGenerating(true);
      axios
        .get(`/csv/poSummaryExcels`, {
          params: {
            PO,
            STY,
            BoxGroup,
            timezone: localStorage.getItem("timezone"),
          },
        })
        .then((res) => {
          window.location.replace(
            process.env.REACT_APP_API_LINK +
              "/api/v1/csv/download?oneTimeToken=" +
              res.data.downloadTokens[0]
          );
          setGenerating(false);
        })
        .catch((err) => {
          console.log(err);
          setGenerating(false);
          alert("Something went wrong!");
        });
    };

    return (
      <button
        className="btn"
        style={{
          all: "unset", // removes ALL default + Bootstrap styles
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => DownloadExcel()}
        disabled={generating}
      >
        {generating ? (
          <Spinner size="lg" />
        ) : (
          <img
            width="37"
            height="37"
            src="https://img.icons8.com/color/48/export-excel.png"
            alt="export-excel"
          />
        )}
      </button>
    );
  };

  const showBarcode = ({ PO, user_to_use, stickerType }) => {
    const fetchPreview = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_LINK}/api/v1/csv/previewBarcodes?PO=${PO}&user_to_use=${user_to_use}`
        );
        console.log("res data", res.data);
        const allData = res.data;
        setBarcodeContent(allData);
        setPreviewHtmlContent({
          PO: PO,
          stickerType: stickerType,
          user_to_use: user_to_use,
        });
        setShowPreviewModal(true);
      } catch (err) {
        console.error("Preview failed:", err);
        // Show modal with error message
        setShowPreviewModal(true);
      }
    };
    fetchPreview();
  };

  const onChangeStickerOptions = async (event) => {
    setSelectedStickerValue(event.target.value);
    setPage(0);
    setEntryByPOdata([]);
    setHasMore(true);

    fetchData(
      sentCheckBox,
      unsentCheckBox,
      0,
      30,
      poSearch,
      event.target.value,
      customerSearch,
      lShimpentSearch,
      type
    );
  };

  const handleCheckedPO = (e, i, PO, BoxGroup) => {
    const updatedPO = checkedPO.map((val, index) => (index === i ? !val : val));
    setCheckedPO(updatedPO);

    const isChecked = updatedPO[i];
    const selectedItem = { PO, BoxGroup };

    setSelectedPOAndBoxgroup((prev) => {
      if (isChecked) {
        return [...prev, selectedItem];
      } else {
        return prev.filter(
          (item) => !(item.PO === PO && item.BoxGroup === BoxGroup)
        );
      }
    });
  };

  const handleBoxGroupMerge = async () => {
    // console.log("selcted po and box gorup", selectedPOAndBoxgorup);
    if (selectedPOAndBoxgorup.length !== 2) {
      toast.remove();
      return toast.error("You can only merge 2 BoxGroups at a time.");
    }
    const hasInvalidBoxGroup = selectedPOAndBoxgorup.some(
      (item) => item.BoxGroup == null || item.BoxGroup === ""
    );

    if (hasInvalidBoxGroup) {
      toast.remove();
      return toast.error("One or more selected BoxGroups are invalid.");
    }
    const [first, second] = selectedPOAndBoxgorup;

    if (first.PO !== second.PO) {
      toast.remove();
      return toast.error(
        "Selected BoxGroups must belong to the same PO to merge."
      );
    }

    const boxGroups = entryByPOdata
      .filter((data) => data.PO === first.PO) // Filter entries matching PO
      .map((data) => data.BoxGroup) // Extract BoxGroup
      .filter(Boolean) // Remove undefined/null if any
      .sort((a, b) => a - b); // Sort numerically ascending

    // console.log('boxgroups ', boxGroups)

    const firstIndex = boxGroups.indexOf(first.BoxGroup);
    const secondIndex = boxGroups.indexOf(second.BoxGroup);

    // Check if both BoxGroups exist and are in sequence
    if (
      firstIndex !== -1 &&
      (secondIndex === firstIndex + 1 || firstIndex === secondIndex + 1)
    ) {
      console.log("ready to go!");
    } else {
      toast.remove();
      return toast.error("Box groups are not in sequence.");
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    });

    if (result.isConfirmed) {
      try {
        setLoadingMergeBoxGroup(true);
        const response = await axios.post(`/csv/mergeBoxgroupByBoxes`, {
          boxgroup1: first.BoxGroup,
          boxgroup2: second.BoxGroup,
          PO: first.PO,
        });

        console.log("response", response.data);
        toast.success("Boxgroups merged successfully!");
        fetchData(
          sentCheckBox,
          unsentCheckBox,
          0,
          30,
          poSearch,
          selectedStickerValue,
          customerSearch,
          lShimpentSearch,
          type
        );
      } catch (error) {
        toast.error("something went wrong!");
        console.log("error: ", error);
      } finally {
        setLoadingMergeBoxGroup(false);
        ctx.setFilteredEntries([]);
      }
    }
  };

  const onChangeFcus = () => {};

  return (
    <>
      <div className="fixed-top">
        <Header />
        <div
          style={{
            flexDirection: unsentCheckBox ? "row" : "row",
          }}
          id={name === "admin" ? "main_" : "main_1"}
        >
          <div
            style={{
              width: unsentCheckBox ? "93%" : "83%",
            }}
            id={name === "admin" ? "main_Container1" : "main_Container"}
          >
            <div
              id="open"
              className="container_1_barcodePdf"
              style={{
                // border: "2px solid red",
                width: "76px",
              }}
            >
              <Form.Check
                type="checkbox"
                value={unsentCheckBox}
                checked={unsentCheckBox}
                onChange={(e) => {
                  setUnsentCheckBox((prev) => !prev);
                  setHasMore(true);
                  fetchData(
                    sentCheckBox,
                    e.target.checked,
                    0,
                    30,
                    poSearch,
                    selectedStickerValue,
                    customerSearch,
                    lShimpentSearch,
                    type
                  );
                }}
                label="Open"
              />
            </div>
            <div
              id="ex_factory"
              className="container_2"
              style={{
                // border: "2px solid green",
                width: "115px",
              }}
            >
              <Form.Check
                type="checkbox"
                checked={sentCheckBox}
                value={sentCheckBox}
                onChange={(e) => {
                  setSentCheckBox((prev) => !prev);
                  setHasMore(true);
                  fetchData(
                    e.target.checked,
                    unsentCheckBox,
                    0,
                    30,
                    poSearch,
                    selectedStickerValue,
                    customerSearch,
                    lShimpentSearch,
                    type
                  );
                }}
                className="ms-3"
                label="Ex Factory"
              />
            </div>
            <div
              className="container_3"
              id="nve_range"
              style={{
                display: name === "admin" || !unsentCheckBox ? "none" : "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                // border: "2px solid red",
                width: new_array.length < 4 ? "fit-content" : "14%",
              }}
            >
              {ctx.userData.admin === 0 && unsentCheckBox && (
                <div
                  style={{
                    display: "flex",
                    // border: ".5px solid blue",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    fontSize: "14px",
                    flexDirection: "column",
                  }}
                >
                  <div id="conatiner_5_p" style={{ width: "126px" }}>
                    Left NVE Range:
                  </div>
                  <div style={{ paddingLeft: "4%" }}>
                    {" "}
                    {ctx.userData.leftBarcode}
                  </div>
                </div>
              )}
            </div>
            <div
              className="container_4_barcodePdf"
              style={{
                // border: ".5px solid red",
                width: "fit-content 172px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "start",
                // width: "144px",
                width: "fit-content",
                flexDirection: "column",
              }}
            >
              <div
                className="fs-6 me-2"
                style={{
                  width: "auto",
                  margin: "0",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                PO#
              </div>
              <div>
                <Form.Control
                  id="po_input"
                  type="text"
                  name="po"
                  maxLength={6}
                  style={{
                    width: "105px",
                    height: "5vh",
                    border: "2px solid black",
                  }}
                  value={poSearch}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevent form submission on Enter
                    }
                  }}
                  onChange={(e) => {
                    setPoSearch(
                      e.target.value.replace(/\D/g, "").toUpperCase()
                    );
                    OnChangeHandleFilter(
                      e.target.value.replace(/\D/g, "").toUpperCase(),
                      customerSearch,
                      lShimpentSearch,
                      type,
                      sentCheckBox,
                      unsentCheckBox,
                      selectedStickerValue
                    );
                    // poSearch,
                    //   customerSearch,
                    //   lShimpentSearch,
                    //   sentCheckBox,
                    //   unsentCheckBox;
                  }}
                  placeholder="PO"
                  autoComplete="off"
                />
              </div>
            </div>

            <div
              className="conatiner_5"
              style={{
                // border: ".5px solid blue",
                width: "fit-content 217px",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "start",
                // width: "200px",
                width: "fit-content",
                flexDirection: "column",
              }}
            >
              <div
                className="fs-6 me-2"
                style={{
                  width: "auto",
                  margin: "0",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                Customer
              </div>
              <Form.Control
                id="customer_input"
                type="text"
                name="po"
                maxLength={10}
                style={{
                  height: "5vh",
                  border: "2px solid black",
                  width: "110px",
                }}
                value={customerSearch}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // Prevent form submission on Enter
                  }
                }}
                onChange={(e) => {
                  setCustomerSearch(e.target.value.replace(/\D/g, ""));
                  setCustomerSearch(e.target.value.replace(/\D/g, ""));
                  OnChangeHandleFilter(
                    poSearch,
                    e.target.value.replace(/\D/g, "").toUpperCase(),
                    lShimpentSearch,
                    type,
                    sentCheckBox,
                    unsentCheckBox,
                    selectedStickerValue
                  );
                }}
                placeholder="Customer"
                autoComplete="off"
              />
            </div>

            <div className="container_7">
              <div
                id="LerrosShipment"
                // className="fs-6 me-2"
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: "600",
                  width: "114px",
                  // border: "2px solid green",
                }}
              >
                Lerros Shipment
              </div>
              <div>
                <Form.Control
                  id="lerros_shipment_input"
                  type="text"
                  name="po"
                  maxLength={8}
                  style={{
                    width: "114px",
                    height: "5vh",
                    border: "2px solid black",
                    // border: "none",
                  }}
                  value={lShimpentSearch}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault(); // Prevent form submission on Enter
                    }
                  }}
                  onChange={(e) => {
                    setlShimpentSearch(e.target.value.replace(/\D/g, ""));
                    setlShimpentSearch(e.target.value.replace(/\D/g, ""));
                    OnChangeHandleFilter(
                      poSearch,
                      customerSearch,
                      e.target.value.replace(/\D/g, "").toUpperCase(),
                      type,
                      sentCheckBox,
                      unsentCheckBox,
                      selectedStickerValue
                    );
                  }}
                  placeholder="Lerros Shipment"
                  autoComplete="off"
                />
              </div>
            </div>

            <div
              className="container_7"
              id="main_po_type"
              style={{
                // border: ".5px solid red",
                // width: "155px",
                width: "fit-content",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "start ",
                flexDirection: "column",
                paddingLeft: "1px",
              }}
            >
              <div
                id="po_type"
                // className="fs-6 me-2"
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: "600",
                  width: "80px",
                  // border: "2px solid green",
                  paddingLeft: "4%",
                }}
              >
                PO# Type
              </div>
              <div>
                <Form.Control
                  id="po_type_input"
                  type="text"
                  name="type"
                  maxLength={1}
                  style={{
                    width: "114px",
                    height: "5vh",
                    border: "2px solid black",
                  }}
                  value={type}
                  onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    setType(value.match(/^[A-Z]$/) ? value : "");
                    OnChangeHandleFilter(
                      poSearch,
                      customerSearch,
                      lShimpentSearch,
                      value,
                      sentCheckBox,
                      unsentCheckBox,
                      selectedStickerValue
                    );
                  }}
                  placeholder="PO# Type"
                  autoComplete="off"
                />
              </div>
            </div>
            <div
              // style={{
              //   padding: unsentCheckBox ? "0.5% 0% 0.5% 4%" : "0% 0% 0% 1%",
              // }}
              id={
                name === "admin" ? "second_main_header" : "second_main_header1"
              }
            >
              <div
                className="conatiner_6"
                style={{
                  // border: "2px solid green",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "start",
                  width: "170px",
                  flexDirection: "column",
                }}
              >
                <div id="conatiner_5_p" style={{ paddingRight: "0% 2% 0% 4%" }}>
                  Sticker
                </div>
                <div>
                  <select
                    id="dropdown_select"
                    style={{
                      border: "2px solid black",
                      height: "5vh",
                      padding: "2% 0%",
                      borderRadius: ".4em",
                      fontSize: "13px",
                      color: "black",
                      width: "96px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: "300",
                    }}
                    onChange={onChangeStickerOptions}
                    value={selectedStickerValue}
                  >
                    <option style={{ fontSize: "14px" }} value={""}>
                      Select Sticker
                    </option>
                    {/* <option style={{ fontSize: "14px" }}>
                  Lerros/Div.07 Key Account/AMG/Carl Gross/Breuninger
                </option> */}
                    <option style={{ fontSize: "14px" }} value={"LERROS"}>
                      Lerros
                    </option>
                    <option style={{ fontSize: "14px" }} value={"MOGSTKOTTO"}>
                      Otto
                    </option>
                    <option style={{ fontSize: "14px" }} value={"MOGSTKFUSS"}>
                      Fussl
                    </option>
                    <option style={{ fontSize: "14px" }} value={"MOGSTKFAMI"}>
                      Familia
                    </option>
                    <option style={{ fontSize: "14px" }} value={"MOGSTKGALI"}>
                      Galileo
                    </option>
                    <option style={{ fontSize: "14px" }} value={"MOGSTKTEO"}>
                      TEO
                    </option>
                    {/* {/ <option style={{ fontSize: "14px" }} value={"MOGSTKHSE"}> /}
                  {/ HSE /}
                  / </option> / */}
                    <option style={{ fontSize: "14px" }} value={"MOGSTKJIMS"}>
                      Jim Spencer
                    </option>
                    <option style={{ fontSize: "14px" }} value={"MOGSTKAMCB"}>
                      AMG
                    </option>
                    {/* {/ <option style={{ fontSize: "14px" }} value={"MOGSTKKAUF"}> /}
                  {/ Kaufland /}
                  {/ </option> /} */}
                    {/* {/ <option style={{ fontSize: "14px" }} value={"MOGSTKTECH"}> /}
                  {/ Techno/PINX /}
                  {/ </option> /} */}
                  </select>
                </div>
              </div>
            </div>

            {/* <div>
              <Button onClick={handleBoxGroupMerge}>
                {loadingMergeBoxGroup ? <Spinner size="lg" /> : "Merge Group"}
              </Button>
            </div> */}
            <div className="d-flex align-items-center">
              <Button
                onClick={handleBoxGroupMerge}
                disabled={loadingMergeBoxGroup}
                className="d-flex align-items-center text-nowrap"
                style={{ width: "155px" }}
              >
                {loadingMergeBoxGroup ? (
                  <>
                    <Spinner size="sm" animation="border" />
                    <span className="ms-4">Merging</span>
                  </>
                ) : (
                  "Merge Box-Groups"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{ marginTop: unsentCheckBox ? "170px" : "164px" }}
        id={name === "admin" ? "table_main_admin" : "table_main_user"}
        className=" mx-4 tableFixHead table-container"
        // style={{
        //   marginTop: name === "admin" ? "165px" : "175px",
        //   marginBottom: "21px",
        //   height: name === "admin" ? "70vh" : "66vh",

        // }}
      >
        {isLoading && !initialFetchDone ? (
          <Loader />
        ) : (
          <div className="table-responsive mx-4 tableFixHead table-container">
            <table className="table table-bordered table-hover table-sm mt-4 table-header-for-all">
              <thead>
                <tr className="table-warning">
                  <th>
                    <div style={{ border: "2px solid #fff3cd" }}>S.No.</div>
                  </th>
                  <th>
                    {/* <div style={{ border: "2px solid #fff3cd",  }}> */}
                    Select
                    {/* </div> */}
                  </th>
                  <th>
                    <div style={{ border: "2px solid #fff3cd" }}>PO#</div>
                  </th>
                  <th style={{ width: "8%", borderTop: "1px solid black" }}>
                    <div style={{ border: "2px solid #fff3cd" }}>Box Group</div>
                  </th>
                  <th style={{ borderRight: "1px solid black" }}>
                    <div style={{ border: "2px solid #fff3cd" }}>Style</div>
                  </th>

                  <th>
                    <div style={{ border: "2px solid #fff3cd" }}>Factory</div>
                  </th>
                  <th>
                    <div style={{ border: "2px solid #fff3cd" }}>User</div>
                  </th>
                  <th>
                    <div style={{ border: "2px solid #fff3cd" }}>Sticker</div>
                  </th>
                  <th>
                    <div
                      style={{
                        border: "2px solid #fff3cd",
                        width: "130px",
                      }}
                    >
                      Lerros Shipment
                    </div>
                  </th>
                  <th style={{ width: "7%" }}>
                    {" "}
                    <div style={{ border: "2px solid #fff3cd" }}>PO# Type</div>
                  </th>
                  <th>
                    <div style={{ border: "2px solid #fff3cd" }}>Customer</div>
                  </th>
                  <th>
                    <div
                      style={{
                        border: "2px solid fff3cd",
                        // width: "140px",
                      }}
                    >
                      Num Of Boxes
                    </div>
                  </th>
                  {/* {ctx.userData.admin === 0 && <th>GenerateBarcode</th>} */}
                  {ctx.userData.admin === 1 ? (
                    <th>
                      <div style={{ border: "2px solid #fff3cd" }}>
                        Print PDF
                      </div>
                    </th>
                  ) : (
                    <th>
                      <div style={{ border: "2px solid #fff3cd" }}>
                        Generate/Print
                      </div>
                    </th>
                  )}
                  <th>Preview</th>

                  {/* <th>Print PDF</th> */}
                  <th>Excel</th>
                </tr>
              </thead>
              {entryByPOdata && entryByPOdata.length > 0 ? (
                <tbody>
                  {entryByPOdata.map((el, i) => {
                    // console.log("entry by po data", el);
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          <div className="form-check d-flex align-items-center justify-content-center">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              // value=""
                              checked={checkedPO[i]}
                              onChange={(e) =>
                                handleCheckedPO(e, i, el.PO, el.BoxGroup)
                              }
                              id="flexCheckDefault"
                            />
                          </div>
                        </td>
                        <td>{el.PO}</td>
                        <td>{el.BoxGroup}</td>
                        <td>{el["STY"]}</td>

                        <td>{el["FACT"]}</td>
                        <td>{el["username"]}</td>
                        {ctx.userData.admin === 1 ? (
                          <td>
                            {/* {el.STYP === "" || !el.STYP ? "LERROS" : el.STYP}  */}
                            <StickerTypeChange
                              stickerType={el.STYP}
                              po={el.PO}
                              onSuccess={() =>
                                OnChangeHandleFilter(
                                  poSearch,
                                  customerSearch,
                                  lShimpentSearch,
                                  type,
                                  sentCheckBox,
                                  unsentCheckBox,
                                  selectedStickerValue
                                )
                              }
                            />
                          </td>
                        ) : (
                          <td>
                            {el.STYP === "" || !el.STYP ? "LERROS" : el.STYP}
                          </td>
                        )}
                        <td>{el.ShipGroup}</td>
                        {ctx.userData.admin === 0 ? (
                          <td>{el.TYP}</td>
                        ) : (
                          <POTypeChange type={el.TYP} po={el.PO} />
                        )}
                        {/* <td>{el.Customer}</td> */}
                        {ctx.userData.admin === 0 ? (
                          <td>{el.Customer}</td>
                        ) : (
                          <FUCSChange fcus={el.Customer} po={el.PO} />
                        )}
                        <td>{el.noOfBoxes}</td>
                        {ctx.userData.admin === 0 ? (
                          <td>
                            <BarcodeButton
                              key={el.PO}
                              PO={el.PO}
                              BoxGroup={el.BoxGroup}
                            />
                          </td>
                        ) : el.BoxGroup ? (
                          <td>
                            <BarcodeButton
                              key={el.PO}
                              PO={el.PO}
                              BoxGroup={el.BoxGroup}
                              user_to_use={el["username"]}
                            />
                          </td>
                        ) : (
                          "Barcode isn’t generated yet"
                          // <td>
                          //   <span
                          //     onClick={() =>
                          //       showBarcode({
                          //         PO: el.PO,
                          //         user_to_use: el["username"],
                          //         stickerType: el.STYP
                          //       })
                          //     }
                          //     style={{ cursor: "pointer" }}
                          //   >
                          //     &#128065;
                          //   </span>
                          // </td>
                        )}
                        <td>
                          <span
                            onClick={() => {
                              if (el.BoxGroup) {
                                toast.error(
                                  "Barcodes already generated. Please download — no preview needed."
                                );
                              } else {
                                showBarcode({
                                  PO: el.PO,
                                  user_to_use: el["username"],
                                  stickerType: el.STYP,
                                });
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            &#128065;
                          </span>
                        </td>

                        <td className="p-0">
                          <ExcelButton
                            key={el.PO}
                            PO={el.PO}
                            STY={el["STY"]}
                            BoxGroup={el.BoxGroup}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                isLoading === false && (
                  <tbody>
                    <tr>
                      <td
                        colSpan="13"
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        <h5>NO DATA FOUND</h5>
                      </td>
                    </tr>
                  </tbody>
                )
              )}
              <tfoot className="border-0">
                <tr className="border-0">
                  <td
                    colSpan={100} // use a large number to span all columns
                    style={{
                      border: "1px solid rgba(254, 254, 254, 0.5)",
                      borderTop: "1px solid #000",
                      // padding: "10px 0",
                      textAlign: "center",
                      backgroundColor: "transparent",
                    }}
                  >
                    {hasMore ? (
                      <div
                        ref={observerRef}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ width: "1.2rem", height: "1.2rem" }}
                        />
                      </div>
                    ) : (
                      entryByPOdata &&
                      entryByPOdata.length > 0 && (
                        <div>
                          <span className="d-flex justify-content-center align-items-center">
                            NO MORE DATA
                          </span>
                        </div>
                      )
                    )}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>

      {/* Preview Modal */}
      <PreviewModal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        previewData={previewHtmlContent}
        content={barcodeContent}
      />
    </>
  );
};

export default BarcodePdf;
